import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { ButtonWithIcon } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { useTranslate } from 'src/hooks';
import { CLAIM_FUND_CREATE_URL } from 'src/pages/Disbursement/ClaimFund/List/constants';

const ClaimFundCreateButton = () => {
  const { getTranslation } = useTranslate();
  return (
    <Link id="btnCreateClaimFund" to={CLAIM_FUND_CREATE_URL}>
      <ButtonWithIcon
        iconName="add"
        onClick={() => {
          AnalyticsManager.instance().track(AnalyticsEvent.create_claim_fund);
        }}
      >
        {getTranslation('pageTitle_createClaimFund')}
      </ButtonWithIcon>
    </Link>
  );
};

export default ClaimFundCreateButton;
